var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.a00ae3889e9a3632b3c6e219e715d304.svg#logo--ewQtF';
                    var viewUrl = 'sprites.a00ae3889e9a3632b3c6e219e715d304.svg#view-logo--ewQtF';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 157 41',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };